import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {NavigationEnd, Router} from '@angular/router';
import {filter, map} from 'rxjs';

@Component({
    selector: 'truelearn-web-skip-to-main-content-link',
    template: `<a [href]="skipToMainLink()" class="visually-hidden-focusable d-flex bg-primary-700 text-white"
        >Skip to main content</a
    >`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkipToMainContentLink {
    private readonly router = inject(Router);

    private currentRouterUrl = toSignal(
        this.router.events.pipe(
            filter((e) => e instanceof NavigationEnd),
            map(() => this.router.url)
        ),
        {initialValue: ''}
    );

    fragmentId = input.required<string>();

    skipToMainLink = computed(() => {
        const currentRouterUrl = this.currentRouterUrl();
        const fragmentId = this.fragmentId();
        if (!currentRouterUrl || !fragmentId) {
            return '';
        }

        if (fragmentId.includes('#')) {
            return '';
        }

        const elemId = '#' + fragmentId;

        const fragmentIndex = currentRouterUrl.lastIndexOf('#');
        if (fragmentIndex === -1) {
            return currentRouterUrl + elemId;
        }

        const fragMatches = currentRouterUrl.substring(fragmentIndex) === elemId;
        if (fragMatches) {
            return currentRouterUrl;
        } else {
            return currentRouterUrl.substring(0, fragmentIndex) + elemId;
        }
    });
}
